export default __webpack_public_path__ + "static/media/f_header.42e62af2.svg";